import RepositoryFactory from '@/repository/RepositoryFactory';
const shiftServiceRepositories = RepositoryFactory.shiftService;

interface BackdoorRequest {
  userId: string;
  facilityId: string;
  role: number;
}

/**
 * 開発環境でcookieを取得するためのAPI
 */
export async function callBackdoor(payload: BackdoorRequest) {
  const { userId, facilityId, role } = payload;
  const response = await shiftServiceRepositories.backdoor.create({
    user_id: userId,
    facility_id: facilityId,
    role: role,
  });
  return response.data;
}

export default {
  callBackdoor,
};
